"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _reactFinalFormArrays = require("react-final-form-arrays");

var _Form = require("../Form");

var _FileField = require("../../FileField");

var _FileFieldItem = require("../../FileFieldItem");

var _utilities = require("../../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["name", "helperText", "disabled", "onAddFile", "onDownloadFile", "onRemoveFile", "readOnly", "uploadProgress", "FileFieldItemProps", "FileFieldItemErrors"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FormFileField = function FormFileField(_ref) {
  var name = _ref.name,
      helperText = _ref.helperText,
      disabled = _ref.disabled,
      _ref$onAddFile = _ref.onAddFile,
      onAddFile = _ref$onAddFile === void 0 ? function () {} : _ref$onAddFile,
      onDownloadFile = _ref.onDownloadFile,
      _ref$onRemoveFile = _ref.onRemoveFile,
      onRemoveFile = _ref$onRemoveFile === void 0 ? function () {} : _ref$onRemoveFile,
      readOnly = _ref.readOnly,
      _ref$uploadProgress = _ref.uploadProgress,
      uploadProgress = _ref$uploadProgress === void 0 ? [] : _ref$uploadProgress,
      FileFieldItemProps = _ref.FileFieldItemProps,
      FileFieldItemErrors = _ref.FileFieldItemErrors,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      rejectedFiles = _useState2[0],
      setRejectedFiles = _useState2[1];

  var formProps = (0, _Form.useFormProps)(); // Custom callback will be used in dirty/pristine form state calculations.

  var isEqual = (0, _react.useCallback)(function (a, b) {
    var A = Array.isArray(a) ? a : [];
    var B = Array.isArray(b) ? b : [];
    return A.length === B.length && A.every(function (item, idx) {
      return item === B[idx];
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalFormArrays.FieldArray, {
    isEqual: isEqual,
    name: name,
    children: function children(_ref2) {
      var fields = _ref2.fields,
          meta = _ref2.meta;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FileField.FileField, _objectSpread(_objectSpread({
        margin: "normal"
      }, rest), {}, {
        disabled: disabled !== null && disabled !== void 0 ? disabled : formProps.disabled,
        error: meta.submitError && !meta.dirtySinceLastSubmit,
        helperText: meta.touched && meta.submitError && !meta.dirtySinceLastSubmit ? meta.submitError : helperText,
        onDrop: function onDrop(files, rejected) {
          files.forEach( /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(file, i) {
              var fileIdx, fileAttributes, fileProps;
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      fileIdx = fields.length + i;
                      fileAttributes = {
                        documentId: (0, _utilities.generateId)(),
                        name: file.name,
                        size: file.size
                      };
                      fields.push(fileAttributes);
                      _context.next = 5;
                      return onAddFile === null || onAddFile === void 0 ? void 0 : onAddFile(file, fileIdx);

                    case 5:
                      fileProps = _context.sent;

                      if (fileProps instanceof Object) {
                        fields.update(fileIdx, _objectSpread(_objectSpread({}, fileAttributes), fileProps));
                      }

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x, _x2) {
              return _ref3.apply(this, arguments);
            };
          }()); // rejected files will not included in formValues state,
          // but they'll still get rendered below with proper error messages.

          setRejectedFiles(function (preValue) {
            return [].concat((0, _toConsumableArray2.default)(preValue), (0, _toConsumableArray2.default)(rejected));
          });
        },
        readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : formProps.readOnly,
        children: [fields.map(function (_name, i) {
          var _uploadProgress$i;

          var file = fields.value[i]; // Ignore rendering a download button if the href is falsy.
          // This ensures that a download button does not show if the user
          // hasn't saved the form.

          var isDownloadable = file.downloadHref || false;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FileFieldItem.FileFieldItem, _objectSpread(_objectSpread({
            disabled: disabled !== null && disabled !== void 0 ? disabled : formProps.disabled,
            downloadHref: onDownloadFile ? null : file.downloadHref,
            error: file.error,
            fileName: file.name,
            fileSize: file.size,
            helperText: file.helperText,
            viewHref: file.viewHref
          }, FileFieldItemProps), {}, {
            LinearProgressProps: {
              value: (_uploadProgress$i = uploadProgress[i]) !== null && _uploadProgress$i !== void 0 ? _uploadProgress$i : 0,
              variant: uploadProgress[i] ? "determinate" : "indeterminate"
            },
            onDelete: function onDelete() {
              fields.remove(i);
              onRemoveFile === null || onRemoveFile === void 0 ? void 0 : onRemoveFile(file, i);
            },
            onDismiss: function onDismiss() {
              // Handle removing files that fail during upload
              fields.remove(i);
              onRemoveFile === null || onRemoveFile === void 0 ? void 0 : onRemoveFile(file, i);
            },
            onDownload: onDownloadFile && isDownloadable ? function () {
              return onDownloadFile(file, i);
            } : undefined,
            readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : formProps.readOnly
          }), file.documentId || (0, _utilities.generateId)());
        }), !(readOnly !== null && readOnly !== void 0 ? readOnly : formProps.readOnly) && rejectedFiles.map(function (_ref4, i) {
          var file = _ref4.file,
              errors = _ref4.errors;
          var errorToShow = errors.length > 0 ? errors[0] : undefined;
          var helperText = errorToShow ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: file.name
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
              children: FileFieldItemErrors[errorToShow.code]
            })]
          }) : FileFieldItemProps.helperText;
          return /*#__PURE__*/(0, _react.createElement)(_FileFieldItem.FileFieldItem, _objectSpread(_objectSpread({}, FileFieldItemProps), {}, {
            error: !!errors.length || FileFieldItemProps.error,
            helperText: helperText,
            key: (0, _utilities.generateId)(),
            onDismiss: function onDismiss() {
              setRejectedFiles(function (preValue) {
                var newValue = (0, _toConsumableArray2.default)(preValue);
                newValue.splice(i, 1);
                return newValue;
              });
            }
          }));
        })]
      }));
    }
  });
};

var _default = FormFileField;
exports.default = _default;